import React from 'react';
import { Spin } from 'antd';
import { isEqual, isEmpty } from 'lodash';
import {WeaTools, WeaErrorPage, WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import EHeader from '../common/EHeader';
import { NoRightCom } from '../../util/common';

//元素组件
class NoReact extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            edata: {},
        }
        this.handleRefresh = this.handleRefresh.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.loadHtml = this.loadHtml.bind(this);
    }
    handleDelete(){
        this.setState({
            edata: null,
        });
    }
    handleRefresh(){
        const { item, isSetting} = this.props.config;
        const { eid, contentview } = item;
        this.loadHtml(eid, contentview.url, isSetting);
    }
    loadHtml(eid, url, isSetting){
        if(url){
            WeaTools.callApi(url, 'GET', {}, 'html').then((result) => {
                if(this.props.config.isHasRight){
                    $(".homepage[data-isSetting="+isSetting+"] #content_view_id_"+eid).html(result);
                }
            });
        }
    }
    componentDidMount(){
        const { item, isSetting} = this.props.config;
        const { eid, contentview } = item;
        this.loadHtml(eid, contentview.url, isSetting);
    }
    componentWillReceiveProps(nextProps){
        const { item, params, isHasRight, isSetting } = this.props.config;
        const config = { item, params, isHasRight };
        const _config = { 
            item: nextProps.config.item, 
            params: nextProps.config.params, 
            isHasRight: nextProps.config.isHasRight,
        };
        if(!isEqual(config, _config) || nextProps.config.isRender){
            const { eid, contentview }  = nextProps.config.item;
            this.loadHtml(eid, contentview.url, isSetting);
        }
    }
    shouldComponentUpdate(nextProps, nextState){
        const { item, params, isHasRight } = this.props.config;
        const config = { item, params, isHasRight };
        const _config = { 
            item: nextProps.config.item, 
            params: nextProps.config.params, 
            isHasRight: nextProps.config.isHasRight,
        };
        return !isEqual(this.state, nextState) || !isEqual(config, _config)
    }
    render() {
        const { edata, refresh } = this.state;
        const { config, fontSizeMp } = this.props;

        if(!config || !edata) return <div/>;
        const { isHasRight, item } = config;
        const { eid, ebaseid, contentview, style } = item;
        const { style: style1= {} } = contentview;
        let EContentHtml = <div/>;
        if(!isHasRight){
             EContentHtml = <NoRightCom/> 
        }
        return <div className="item"
                    style={style}
                    id={`item_${eid}`} 
                    data-eid={eid} data-ebaseid={ebaseid} 
                    data-needRefresh={item.needRefresh} 
                    data-cornerTop={item.cornerTop} 
                    data-cornerTopRadian={item.cornerTopRadian}
                    data-cornerBottom={item.cornerBottom} 
                    data-cornerBottomRadian={item.cornerBottomRadian}>
                    <EHeader config={config} handleRefresh={this.handleRefresh} handleDelete={this.handleDelete} fontSizeMp={fontSizeMp}/>
                    <div className="setting" id={`setting_${eid}`}></div>
                    <div className="content" id={`content_${eid}`} style={{width:'auto',_width:'100%'}}>
                        <div className="content_view" id={`content_view_id_${eid}`} style={{height: style1.height}}>
                            <Spin spinning={refresh}>{EContentHtml}</Spin>
                        </div>
                        <div style = {{textAlign:'right'}} id={`footer_${eid}`}></div>
                    </div>
            </div>;
    }
}
class MyErrorHandler extends React.Component {
    render() {
        const hasErrorMsg = this.props.error && this.props.error !== "";
            return ( <WeaErrorPage msg = { hasErrorMsg ? this.props.error : getLabel(385218,"对不起，该页面异常，请联系管理员！") }/>
        );
    }
}
NoReact = WeaTools.tryCatch(React, MyErrorHandler, { error: "" })(NoReact);
export default NoReact;






// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/noreact/index.js